import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

type OnboardingProcessStepsDto = ClientInferResponseBody<
  typeof contract.onboardingProcessSteps.list,
  200
>;
export type OnboardingProcessStep = OnboardingProcessStepsDto[number];

export const fetchOnboardingProcessSteps = async (): Promise<OnboardingProcessStep[]> => {
  const response = await api.onboardingProcessSteps.list.query();

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
